import { NgModule } from "@angular/core";
import { DirtyCheckGuard } from "./guards/dirty-check.guard";
import { AuthGuardService } from "./services/auth-guard.service";

import { RouterModule, Routes } from "@angular/router";
import { LoginPageComponent } from "./pages/login/login.component";
import { SettingsPageComponent } from "./pages/settings/settings.component";
import { HomePageComponent } from "./pages/home/home.component";
import { PublishPageComponent } from "./pages/publish/publish.component";
import { CMSPageComponent } from "./pages/cms/cms.component";

import { BuilderPageComponent } from "./pages/builder/builder.component";
import { NotfoundComponent } from "./pages/errors/notfound/notfound.component";
import { AccessDeniedComponent } from "./pages/errors/denied/denied.component";
import { ServererrorComponent } from "./pages/errors/servererror/servererror.component";

const routes: Routes = [
  { path: "", redirectTo: "reports", pathMatch: "full" },
  {
    path: "login",
    component: LoginPageComponent,
    title: "Quantivate - Login",
  },

  {
    path: "home",
    redirectTo: "reports",
    pathMatch: "full",
  },

  {
    path: "settings",

    children: [
      {
        path: "",
        component: SettingsPageComponent,
        title: "Quantivate - Content Management",
        canActivate: [AuthGuardService],
        data: {
          path: "settings",
        },
      },
      {
        path: "cms",
        component: CMSPageComponent,
        title: "Quantivate - Content Management",
        canActivate: [AuthGuardService],
        data: {
          path: "cms",
        },
      },
      {
        path: "publish",
        component: PublishPageComponent,
        title: "Quantivate - Publishing",
        canActivate: [AuthGuardService],
        data: {
          path: "publishing",
        },
      },
    ],
  },

  {
    path: "reports",
    children: [
      {
        path: "",
        component: HomePageComponent,
        title: "Quantivate - Reports",
        data: {
          canvasType: "report",
        },
      },
      {
        path: "edit/:id",
        component: BuilderPageComponent,
        canDeactivate: [DirtyCheckGuard],
        title: "Quantivate - Builder",
        data: {
          canvasMode: "edit",
          canvasType: "report",
        },
      },
      {
        path: "view/:id",
        component: BuilderPageComponent,
        title: "Quantivate - View Report",
        data: {
          canvasMode: "view",
          canvasType: "report",
        },
      },
      {
        path: "preview/:id",
        component: BuilderPageComponent,
        title: "Quantivate - View Report",
        canActivate: [AuthGuardService],
        data: {
          path: "preview",
          isPreview: true,
          canvasMode: "view",
          canvasType: "report",
        },
      },
    ],
  },
  {
    path: "dashboards",
    children: [
      {
        path: "",
        component: HomePageComponent,

        title: "Quantivate - Dashboards",
        data: {
          canvasMode: "index",
          canvasType: "dashboard",
        },
      },
      {
        path: "edit/:id",
        component: BuilderPageComponent,
        canDeactivate: [DirtyCheckGuard],
        title: "Quantivate - Builder",
        data: {
          canvasMode: "edit",
          canvasType: "dashboard",
        },
      },
      {
        path: "view/:id",
        component: BuilderPageComponent,
        canDeactivate: [DirtyCheckGuard],
        title: "Quantivate - View Dashboard",
        data: {
          canvasMode: "view",
          canvasType: "dashboard",
        },
      },
    ],
  },
  {
    path: "accessdenied",
    component: AccessDeniedComponent,
    title: "Quantivate - Access Denied",
  },
  {
    path: "404",
    component: NotfoundComponent,
    title: "Quantivate - Page Not Found",
  },
  {
    path: "500",
    component: ServererrorComponent,
    title: "Quantivate - Internal Server Error",
  },
  { path: "**", redirectTo: "/404" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: "reload" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
